'use strict'

let env = process.env.NODE_ENV
const isProduction = env === 'production'
env = env.toUpperCase()

export const GOOGLE_ANALYTICS_ID = 'UA-32120185-31'

// request status
export const STATUS_IS_LOADING = 1
export const STATUS_SUCCESS = 2
export const STATUS_FAILED = 3

// session items
export const SESSION_RAND_ID = isProduction ? '99_SESSION_RAND_ID' : `99_SESSION_RAND_ID_${env}`

export const SESSION_HEADERS = isProduction ? '99_EMPRESAS_SESSION' : `99_EMPRESAS_SESSION_${env}`

export const SESSION_USER = isProduction ? '99_EMPRESAS_USER' : `99_EMPRESAS_USER_${env}`

export const SESSION_COMPANY = isProduction ? '99_EMPRESAS_COMPANY' : `99_EMPRESAS_COMPANY_${env}`

export const SESSION_GRAY_USER_V4 = isProduction
  ? '99_EMPRESAS_GRAY_USER_V4'
  : `99_EMPRESAS_GRAY_USER_V4_${env}`
export const V3_TOKEN = isProduction ? '99_EMPRESAS_V3_TOKEN' : `99_EMPRESAS_V3_TOKEN_${env}`
export const SESSION_ALLOWED_GEOLOCATION = isProduction
  ? '99_EMPRESAS_GEOLOCATION'
  : `99_EMPRESAS_GEOLOCATION_${env}`

export const WELCOME_DIALOG_VISIBILITY = isProduction
  ? '99_WELCOME_DIALOG_VISIBILITY'
  : `99_WELCOME_DIALOG_VISIBILITY_${env}`

export const SESSION_WELCOME = isProduction ? '99_EMPRESAS_WELCOME' : `99_EMPRESAS_WELCOME_${env}`

export const COST_CENTER_COUNTER = isProduction
  ? '99_EMPRESAS_COST_CENTER_COUNTER'
  : `99_EMPRESAS_COST_CENTER_COUNTER_${env}`

export const SESSION_SKIP_WIZARD = isProduction
  ? '99_EMPRESAS_SKIP_WIZARD'
  : `99_EMPRESAS_SKIP_WIZARD_${env}`

export const SESSION_FAVORITE_ADDRESS = isProduction
  ? '99_EMPRESAS_FAVORITE_ADDRESS'
  : `99_EMPRESAS_FAVORITE_ADDRESS_${env}`

// seconds * minutes * hours
export const SESSION_TIME = 60 * 60 * 24 * 30 // 86400 / 24h

export const SESSION_EXPIRES_TIME = isProduction
  ? '99_EMPRESAS_SESSION_EXPIRES_TIME'
  : `99_EMPRESAS_SESSION_EXPIRES_TIME_${env}`

export const SESSION_EXPIRES_TIME_VALUE = 30
export const SESSION_EXPIRES_TIME_UNIT = 'days'

export const SESSION_EXPIRES_WARNING_VALUE = 5
export const SESSION_EXPIRES_WARNING_UNIT = 'minutes'

// path to redirect to page on login
export const REDIRECT_PATH_ON_AUTH = '99_EMPRESAS_REDIRECT_PATH_ON_AUTH'

// 新项目的域名，用于postMessage通信
export const NEW_PROJECT_DOMAIN = isProduction ? '*' : '*'
